import { doGetCall } from "../config/rest";

export const FETCH_PARTNERSEARCHCONTENTDATA_BEGIN = "FETCH_PARTNERSEARCHCONTENTDATA_BEGIN";
export const FETCH_PARTNERSEARCHCONTENTDATA_SUCCESS = "FETCH_PARTNERSEARCHCONTENTDATA_SUCCESS";
export const FETCH_PARTNERSEARCHCONTENTDATA_FAILURE = "FETCH_PARTNERSEARCHCONTENTDATA_FAILURE";

export const fetchPartnerSearchContentDataBegin = () => ({
  type: FETCH_PARTNERSEARCHCONTENTDATA_BEGIN,
});

export const fetchPartnerSearchContentDataSuccess = (PartnerSearchContentPageResponse, PartnerSearchContentPageComponents) => ({
  type: FETCH_PARTNERSEARCHCONTENTDATA_SUCCESS,
  totalResponse: { PartnerSearchContentPageResponse },
  payload: { PartnerSearchContentPageComponents },
});

export const fetchPartnerSearchContentDataFailure = (error) => ({
  type: FETCH_PARTNERSEARCHCONTENTDATA_FAILURE,
  payload: { error },
});

function getPartnerSearchContentPageComponents() {
  return doGetCall(`/wp-json/wp/v2/pages?slug=partner`);
}

export function fetchPartnerSearchContentPageComponents() {
  return (dispatch) => getPartnerSearchContentPageComponents()
    .then((json) => {
      dispatch(fetchPartnerSearchContentDataSuccess(json[0], json[0].acf));
      return json;
    })
    .catch((error) => dispatch(fetchPartnerSearchContentDataFailure(error)));
}
